// extracted by mini-css-extract-plugin
module.exports = {"swiper-wrapper":"sliding-tab-content_swiper-wrapper__33zxf"};